import { useState } from 'react';
import ProfileForm from './components/ProfileForm';
import ProfileList from './components/ProfileList';

const AUTH_USERNAME = 'walidsafi';
const AUTH_PASSWORD = 'walidsafi';
const AUTH_STORAGE_KEY = 'profiles_app_authenticated';

function App() {
  const [tab, setTab] = useState('list');
  const [refreshKey, setRefreshKey] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem(AUTH_STORAGE_KEY) === 'true'
  );
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');

  const handleCreated = () => {
    setRefreshKey((k) => k + 1);
    setTab('list');
  };

  const handleLogin = (event) => {
    event.preventDefault();

    if (loginForm.username === AUTH_USERNAME && loginForm.password === AUTH_PASSWORD) {
      localStorage.setItem(AUTH_STORAGE_KEY, 'true');
      setIsAuthenticated(true);
      setLoginForm({ username: '', password: '' });
      setLoginError('');
      return;
    }

    setLoginError('Username or password is incorrect');
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    setIsAuthenticated(false);
    setTab('list');
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-[#09090b] relative flex items-center justify-center px-6">
        <div className="fixed inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gradient-to-b from-purple-500/8 via-purple-500/3 to-transparent rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-[500px] h-[400px] bg-gradient-to-tl from-blue-500/5 to-transparent rounded-full blur-3xl" />
        </div>

        <form
          onSubmit={handleLogin}
          className="relative z-10 w-full max-w-sm border border-white/[0.08] bg-white/[0.03] rounded-xl p-6 shadow-2xl shadow-black/20"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-purple-500/10 border border-purple-500/20 flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-purple-400">
                <rect x="3" y="11" width="18" height="10" rx="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-white tracking-tight">Login</h1>
              <p className="text-xs text-zinc-500 font-medium">SquidSelfie Manager</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-[10px] font-medium text-zinc-500 mb-1.5 uppercase tracking-wider">Username</label>
              <input
                value={loginForm.username}
                onChange={(event) => setLoginForm((form) => ({ ...form, username: event.target.value }))}
                autoComplete="username"
                className="w-full px-3 py-2.5 rounded-lg border border-white/[0.08] bg-white/[0.04] text-sm text-zinc-100 placeholder-zinc-600 outline-none focus:border-white/20 transition-all duration-150"
              />
            </div>
            <div>
              <label className="block text-[10px] font-medium text-zinc-500 mb-1.5 uppercase tracking-wider">Password</label>
              <input
                type="password"
                value={loginForm.password}
                onChange={(event) => setLoginForm((form) => ({ ...form, password: event.target.value }))}
                autoComplete="current-password"
                className="w-full px-3 py-2.5 rounded-lg border border-white/[0.08] bg-white/[0.04] text-sm text-zinc-100 placeholder-zinc-600 outline-none focus:border-white/20 transition-all duration-150"
              />
            </div>
          </div>

          {loginError && (
            <div className="mt-4 px-3 py-2 rounded-lg bg-red-500/10 border border-red-500/20 text-xs text-red-300">
              {loginError}
            </div>
          )}

          <button
            type="submit"
            className="mt-5 w-full px-4 py-2.5 rounded-lg bg-white text-[#09090b] text-sm font-medium hover:bg-zinc-200 active:scale-[0.99] transition-all"
          >
            Sign in
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090b] relative">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gradient-to-b from-purple-500/8 via-purple-500/3 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[400px] bg-gradient-to-tl from-blue-500/5 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 py-12">
        <div className="mb-10 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-purple-400">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                <circle cx="12" cy="9" r="3"/>
                <path d="M12 15c-3.33 0-6 1.34-6 3v1h12v-1c0-1.66-2.67-3-6-3z"/>
              </svg>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-white tracking-tight">Profiles 0.1</h1>
              <p className="text-xs text-zinc-500 font-medium">SquidSelfie Manager</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white/[0.04] border border-white/[0.08] text-xs font-medium text-zinc-400 hover:bg-white/[0.08] hover:text-zinc-200 transition-all"
            title="Logout"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Logout
          </button>
        </div>

        <div className="flex gap-1 mb-8 p-1 bg-white/[0.03] border border-white/[0.06] rounded-xl w-fit">
          <button
            onClick={() => setTab('list')}
            className={`px-5 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
              tab === 'list'
                ? 'bg-white/[0.08] text-white shadow-sm'
                : 'text-zinc-500 hover:text-zinc-300'
            }`}
          >
            All Profiles
          </button>
          <button
            onClick={() => setTab('create')}
            className={`px-5 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
              tab === 'create'
                ? 'bg-white/[0.08] text-white shadow-sm'
                : 'text-zinc-500 hover:text-zinc-300'
            }`}
          >
            New Profile
          </button>
        </div>

        <div className="border-t border-white/[0.06] mb-8" />

        {tab === 'list' && <ProfileList refreshKey={refreshKey} />}
        {tab === 'create' && <ProfileForm onCreated={handleCreated} />}
      </div>
    </div>
  );
}

export default App;
